import { Component } from "@angular/core";

@Component({
    selector: 'admin-layout',
    templateUrl: './admin.layout.html',
    styleUrls: ['./admin.layout.scss']
})
export class AdminLayout {
    //
}